import "../../styles/AboutSerene-2.css";
import centerImage from "../../assets/palms-images/plams-bg-flower.png";
import VessellaLogo from "../../assets/images/logo/blue-v-logo.png";

import { motion } from "framer-motion";

const containerLeft = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.25,
        },
    },
};

const containerRight = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.25,
        },
    },
};

const leftItem = {
    hidden: {
        opacity: 0,
        x: -60,
        filter: "blur(10px)",
    },
    visible: {
        opacity: 1,
        x: 0,
        filter: "blur(0px)",
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const rightItem = {
    hidden: {
        opacity: 0,
        x: 60,
        filter: "blur(10px)",
    },
    visible: {
        opacity: 1,
        x: 0,
        filter: "blur(0px)",
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

export default function AboutSereneTwo() {
    const mobilePoints = [
        "Vessella Group presents an exclusive collection of meticulously crafted villas in Hyderabad's most sought-after locations. Each residence is a true expression of refined luxury, timeless elegance, and uncompromising quality.",
        "More than just homes, these villas are thoughtfully designed sanctuaries that elevate everyday living into an exceptional lifestyle experience.",
        "Discover a place where craftsmanship, trust, and attention to detail come together - welcome to life, perfected with Vessella Group.",
        "Villas are the ultimate backdrop for life's most treasured celebrations.",
    ];

    return (
        <section className="serene-narrative container-fluid position-relative" id="about-serene">
            <div className="serene-bottom-overlay"></div>
            <div className="container position-relative z-1">
                {/* MOBILE LAYOUT */}
                <div className="serene-mobile-layout">
                    {/* <div className="serene-mobile-image-wrap">
                        <img src={centerImage} alt="Palms flower artwork" className="serene-mobile-image" />
                    </div> */}

                    <div className="serene-mobile-content">
                        <img src={VessellaLogo} alt="Vessella Group logo" className="serene-mobile-logo" />

                        <h3 className="serene-mobile-heading">
                            The perfect landmark for luxury living, shaped by over 15 years of trusted villa construction expertise.
                        </h3>

                        <div className="serene-mobile-points">
                            {mobilePoints.map((point) => (
                                <div className="serene-mobile-point" key={point}>
                                    <p>{point}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row justify-content-between">
                    {/* LEFT COLUMN */}
                    <motion.div
                        className="col-lg-4 serene-col serene-left p-0"
                        variants={containerLeft}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.35 }}
                    >
                        <motion.div>
                            <img src={VessellaLogo} alt="" className="mb-4" style={{ width: "220px" }} />
                        </motion.div>

                        <motion.div className="serene-item" variants={leftItem}>
                            <h3 style={{ color: "#292d5c" }}>
                                The perfect landmark for luxury living, shaped by over 15 years of trusted villa construction expertise.
                            </h3>
                            {/* <span className="line"></span> */}
                        </motion.div>
                    </motion.div>

                    {/* CENTER IMAGE */}
                    <div className="col-lg-4 d-none serene-center text-center p-0">
                        <img src={centerImage} alt="Serene Living" className="img-fluid serene-image" />
                    </div>

                    {/* RIGHT COLUMN */}
                    <motion.div
                        className="col-lg-4 serene-col serene-right p-0"
                        variants={containerRight}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.35 }}
                    >
                        <motion.div className="serene-item" variants={rightItem}>
                            <p>
                                Vessella Group presents an exclusive collection of meticulously crafted villas in Hyderabad's most sought-after locations. Each residence is a true expression of refined luxury, timeless elegance, and uncompromising quality.
                            </p>
                            {/* <span className="line"></span> */}
                        </motion.div>

                        <motion.div className="serene-item bordered" variants={rightItem}>
                            <p>
                                More than just homes, these villas are thoughtfully designed sanctuaries that elevate everyday living into an exceptional lifestyle experience.
                            </p>
                        </motion.div>

                        <motion.div className="serene-item" variants={rightItem}>
                            <p>
                                Discover a place where craftsmanship, trust, and attention to detail come together - welcome to life, perfected with Vessella Group.
                            </p>
                            {/* <span className="line"></span> */}
                        </motion.div>

                        <motion.div className="serene-item bordered" variants={rightItem}>
                            <p>Villas are the ultimate backdrop for life's most treasured celebrations.</p>
                            <span className="line long"></span>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
